import { render, staticRenderFns } from "./addGoodsType.vue?vue&type=template&id=53848e7c&scoped=true"
import script from "./addGoodsType.vue?vue&type=script&lang=js"
export * from "./addGoodsType.vue?vue&type=script&lang=js"
import style0 from "./addGoodsType.vue?vue&type=style&index=0&id=53848e7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53848e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53848e7c')) {
      api.createRecord('53848e7c', component.options)
    } else {
      api.reload('53848e7c', component.options)
    }
    module.hot.accept("./addGoodsType.vue?vue&type=template&id=53848e7c&scoped=true", function () {
      api.rerender('53848e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/addGoodsType/addGoodsType.vue"
export default component.exports